export default "__VITE_ASSET__C0JB9Xrt__"